import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ChecklistFacade {
  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetChecklist(language: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Checklist?language=' + language);
  }

  GetChecklistData(taskId: number, checklistId: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Checklist/Detail?TaskId=' + taskId + '&checklistId=' + checklistId);
  }

  GetActive(catDetTaskTypeId: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Checklist/Active?catDetTaskTypeId=' + catDetTaskTypeId);
  }

  GetCreated(activStoreId: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Checklist/Created?activStoreId=' + activStoreId);
  }

  GetInstructionInventory(taskId: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/ChecklistInstruction/Inventory?taskId=' + taskId);
  }

  SaveChecklist(parameters: any): Observable<any> {
    const body = JSON.stringify(parameters);
    return this._httpClient.post(this._urlBase + 'api/Task/', body, {
      headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }

  SaveChecklistTemplate(parameters: any): Observable<any> {
    const body = JSON.stringify(parameters);

    return this._httpClient.post(this._urlBase + 'api/Checklist/NewTemplate', body, {
      headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }

  EditChecklist(parameters: any): Observable<any> {
    const body = JSON.stringify(parameters);

    return this._httpClient.put(this._urlBase + 'api/Task/', body, {
      headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }
}
